export interface LogoConfig {
  src: string | string[];
  alt: string;
  label?: string;
  labelFont?: string;
  className?: string;
  additionalClasses?: string;
  mobileClasses?: string;
}

export const INTEGRATION_LOGOS: LogoConfig[] = [
  {
    src: "/media/apple-wallet-seeklogo.png",
    alt: "Apple Wallet",
    label: "Apple Wallet",
    labelFont: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", sans-serif',
    mobileClasses: "max-h-5 max-w-[20px]"
  },
  {
    src: "/media/google-wallet.svg",
    alt: "Google Wallet",
    mobileClasses: "max-h-12 max-w-[120px]"
  },
  {
    src: ["/media/Canva Icon logo.svg", "/media/Canva type logo.svg"],
    alt: "Canva",
    mobileClasses: "max-h-7 max-w-[60px]"
  },
  {
    src: "/media/dotypos.png",
    alt: "Dotypos",
    additionalClasses: "invert dark:invert-0"
  },
  {
    src: "/media/Google-Maps-Logo.png",
    alt: "Google Maps",
    mobileClasses: "max-h-12 max-w-[120px]"
  },
  {
    src: "/media/stripe-integration-logo.png",
    alt: "Stripe"
  }
];
